import { State } from "../store";

export const upgradeDialogOpenDialogSelector = (state: State) =>
  state.upgradeDialog.openDialog;

export const upgradeDialogCloseDialogSelector = (state: State) =>
  state.upgradeDialog.closeDialog;

export const upgradeDialogIsOpenSelector = (state: State) =>
  state.upgradeDialog.isOpen;

export const coachAppDialogIsOpenSelector = (state: State) =>
  state.coachAppDialog.isOpen;

export const coachAppDialogHasUnreadSelector = (state: State) =>
  state.coachAppDialog.hasUnread;

export const coachAppDialogOpenDialogSelector = (state: State) =>
  state.coachAppDialog.openDialog;

export const coachAppDialogCloseDialogSelector = (state: State) =>
  state.coachAppDialog.closeDialog;

export const coachAppDialogSetUnreadSelector = (state: State) =>
  state.coachAppDialog.setUnread;

export const tasksSheetIsOpenSelector = (state: State) =>
  state.tasksSheet.isOpen;

export const tasksSheetHighlightTaskIdSelector = (state: State) =>
  state.tasksSheet.highlightTaskId;

export const tasksSheetOpenSelector = (state: State) =>
  state.tasksSheet.openSheet;

export const tasksSheetCloseSelector = (state: State) =>
  state.tasksSheet.closeSheet;
